angular.module('SpidApp')

.controller('OrderListController', 
		['BASE_PUBLIC_URL', '$scope', '$state', '$rootScope', '$localStorage', '$filter', '_', 'VacationService', 'Toaster', 'ConfigService', 'OrderService', '$timeout', 
function (BASE_PUBLIC_URL,   $scope,   $state,   $rootScope,   $localStorage,   $filter,   _,   VacationService,   Toaster,   ConfigService,   OrderService,   $timeout) {

	$scope.filter = {};
	$scope.filteredOrders = [];
	$scope.sort = 'lastStatus.updated_at';
    $scope.asc = true;
	$scope.statusCountArray = [];
	var filterArraySaved = [];
	
	$scope.currentPage 			= 1;
	$scope.maxPaginationSize 	= 10;
	$scope.itemsPerPage 		= 15;

    ConfigService.all().then(function (config) {
        OrderService.getByAgencyId(config.agencyId).then(function (data) {
            $scope.aOrder = _.chain(data).groupBy(function (obj) {
                return obj.order_id+'#'+obj.lot;
            }).sortBy(function (obj) {
                return moment(obj.updated_at);
            }).map(function (group) {

                var oStatus = _.chain(group).sortBy('status_updated_at', function (obj) {
                    return moment(obj.status_updated_at, moment.ISO_8601).fromNow();
                });

                var aStatus = oStatus.value();
                var lastIndexStatus = oStatus.findLastIndex().value();
                var lastStatus = aStatus[lastIndexStatus];
                $scope.statusCountArray[lastStatus.status] = ($scope.statusCountArray[lastStatus.status] || 0) + 1;
                
                return {
                	orders_id	: group[0].orders_id,
                    lot 		: group[0].lot,
                    lastStatus	: lastStatus,
                    firstStatus	: aStatus[0]
                }
            }).value();
            
            initFilterArrayDefault();
            $scope.filterOrder();
        });
    });

    $scope.resetFilterArray = function($event) {
    	if ($event) {
			$event.preventDefault()
			$event.stopPropagation()
		}
    	$scope.filterArray = _.map(filterArraySaved, _.clone);
    	$scope.toggleFilter('init');
    }
    
    $scope.filterOrder = function() {
    	filterArraySaved =  _.map($scope.filterArray, _.clone);
    	$scope.filteredOrders = $filter('ordersByStatus')($scope.aOrder, $scope.filterArray);
    	$scope.pageChanged();
    }
    
    $scope.toggleFilter = function(id) {
    	if (!id && id !== 0) {
    		$scope.filterArray = _($scope.filterArray).map(function(filter) {
    			filter.checked = $scope.filter.all;
    			return filter;
    		})
    	} 
    	else {
    		$scope.filter.all = true;
    		for(var i = 0; i < $scope.filterArray.length ; i++) {
    			if (!$scope.filterArray[i].checked) {
    				$scope.filter.all = false;
    				break;
    			}
    		}
    	}
    }
    
    var initFilterArrayDefault = function() {
    	$scope.filterArray = [
                  { id: 0, label: 'ORDER_STATUS_CREATE',       checked: true }
                , { id: 1, label: 'STATUS_CANCEL',             checked: true }
                , { id: 2, label: 'ORDER_STATUS_TODO',         checked: true }
                , { id: 3, label: 'ORDER_STATUS_IN_PROGRESS',  checked: true }
                , { id: 4, label: 'ORDER_STATUS_SEND_PART',    checked: true }
                , { id: 5, label: 'ORDER_STATUS_SEND',         checked: true }
                , { id: 6, label: 'ORDER_STATUS_RECEIVE_PART', checked: true }
                , { id: 7, label: 'ORDER_STATUS_RECEIVE',      checked: true }
                , { id: 8, label: 'STATUS_CLOSE',              checked: false }
       	 ];
    }

    
    $scope.pageChanged = function() {
    	$scope.totalItems = $scope.filteredOrders.length;
    	var deb = ($scope.currentPage - 1) * $scope.itemsPerPage;
    	var fin = deb + $scope.itemsPerPage;
    	
    	$scope.pagerOrders = $scope.filteredOrders.slice(deb, fin);
    };
    
    $scope.printOrderList = function() {
    	$scope.dateNow = moment(new Date()).format('LLL');
		
    	$timeout(function() {
    		window.print();
    	}, 50);
    }
}]);